import type { DeviceType } from '../../data/datasources/DeviceTokenRemoteDataSource.js';
import type { IDeviceTokenRepository } from '../repositories/IDeviceTokenRepository.js';

interface Deps { deviceTokenRepository: IDeviceTokenRepository; }

export function createRegisterDeviceTokenUseCase({ deviceTokenRepository }: Deps) {
  return function registerDeviceToken(input: { userId: string; fcmToken: string; deviceType: DeviceType }): Promise<void> {
    return deviceTokenRepository.register(input);
  };
}
